var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKingBed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 30 30"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#king_bed_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m17.473 9.027.367-2.78a.208.208 0 0 0-.3-.217l-1.19.929a.205.205 0 0 1-.303-.045L14.87 5.196a.206.206 0 0 0-.311 0l-1.176 1.718a.205.205 0 0 1-.303.045l-1.19-.907a.208.208 0 0 0-.3.217l.367 2.758z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  clipPath: "url(#king_bed_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.656 16.148v-1.992a1.33 1.33 0 0 1 1.328-1.328h5.313a1.33 1.33 0 0 1 1.328 1.328v1.992M14.625 16.148v-1.992a1.33 1.33 0 0 1 1.328-1.328h5.313a1.33 1.33 0 0 1 1.328 1.328v1.992"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.435 16.148h16.38a1.77 1.77 0 0 1 1.771 1.771v4.206H4.664v-4.206a1.77 1.77 0 0 1 1.77-1.77M4.664 22.125v2.656M24.586 22.125v2.656"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.594 16.148v-5.976a1.33 1.33 0 0 0-1.328-1.328H7.984a1.33 1.33 0 0 0-1.328 1.328v5.976"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "king_bed_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.375 3h8.5v8.5h-8.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "king_bed_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4 6.188h21.25v21.25H4z"
})))));
export default SvgKingBed;